import React, {useContext, useEffect, useState} from 'react';
import {Tree} from "primereact/tree";
import {FaCheck, FaMapMarker, FaTrash} from "react-icons/fa";
import Button from "../../../../../components/button/button.jsx";
import {AreaLayerContext} from "../area-layer-context.jsx";

let canRemovePolygon = true

const PanelKmz = ({kmzData, removePolygon, createPolygon, showKmzPanel, setShowKmzPanel, coreLib, map}) => {
    const {setIsLoading, setAreas} = useContext(AreaLayerContext)
    const [kmzSelected, setKmzSelected] = useState([]);
    const [selectionNodeKeys, setSelectionNodeKeys] = useState([]);
    const [preListAreas, setPreListAreas] = useState([])

    useEffect(() => {
        if (!showKmzPanel) {
            if (canRemovePolygon) {
                for (const kmz of kmzSelected) {
                    const area = preListAreas.find(a => a.id === kmz.key)
                    removePolygon(area?.polygon)
                }
            }
            setKmzSelected([])
            setSelectionNodeKeys([])
            setPreListAreas([])

        }
    }, [showKmzPanel]);

    useEffect(() => {
        if (!coreLib) return

        const bounds = new coreLib.LatLngBounds();
        const preList = []
        for (const kmz of kmzSelected) {
            const {key, Coordinates, label} = kmz

            const paths = []
            for (const coordinate of Coordinates) {
                bounds.extend(new coreLib.LatLng(coordinate.y, coordinate.x));
                paths.push({lat: coordinate.y, lng: coordinate.x})
            }

            const areaFind = preListAreas.find(a => a.id === key)
            removePolygon(areaFind?.polygon)

            const area = createPolygon({
                id: key,
                paths,
                draggable: false,
                editable: false,
                name: label
            })

            preList.push(area)
        }

        if (preList.length) map.fitBounds(bounds);

        setPreListAreas(preList);
    }, [kmzSelected, coreLib]);

    const templateToTree = ({icon_custom, label, id, children}) => {
        if (children && children.length > 0) {
            return (
                <div className={"p-tree-node flex items-center gap-2 p-1"}>
                    <span className="p-tree-node-label">{label}</span>
                </div>
            );
        }

        return (
            <div key={id} className="p-tree-node flex items-center gap-2 p-1">
                { icon_custom && <FaMapMarker /> }
                <span className="p-tree-node-label">{label}</span>
            </div>
        );
    }

    const onSelectionChange = ({value}) => {
        setIsLoading(true)
        const keys = Object.keys(value);
        const kmz = getKmzSelect(keys, kmzData);

        const kmzRemoved = kmzSelected.filter(a => !kmz.some(b => b.key === a.key));
        if (kmzRemoved.length) {
            for (const k of kmzRemoved){
                const area = preListAreas.find(a => a.id === k.key)
                removePolygon(area?.polygon)
            }

            const keysToRemove = new Set(kmzRemoved.map(item => item.key));
            setPreListAreas(prev =>
                prev.filter(item => !keysToRemove.has(item.id))
            );
        }

        setKmzSelected(kmz);
        setSelectionNodeKeys(value);
        setIsLoading(false)
    }

    const getKmzSelect = (keys, data) => {
        const result = [];

        keys.forEach(key => {
            const find = data.find(item => item.key === key);

            if (find) {
                if (find.children) result.push(...getKmzSelect(keys, find.children));
                else if (find.type) result.push(find);
            }
        });

        return result;
    }

    const add = () => {
        canRemovePolygon = false
        setAreas(prevState => [...prevState, ...preListAreas])
        setShowKmzPanel(false)
    }

    return (
        <>
            <div className={"mb-3"}>
                <p className={"text-xs font-bold"}>Importação de arquivo</p>
            </div>
            <div className={"mb-3 h-[calc(100vh-150px)] overflow-auto"}>
                {
                    kmzData.length > 0 &&
                    <Tree value={kmzData}
                          className="custom-sub-itens"
                          selectionMode="checkbox"
                          nodeTemplate={templateToTree}
                          selectionKeys={selectionNodeKeys}
                          onSelectionChange={onSelectionChange}
                    />
                }
            </div>

            <div className={"flex justify-end gap-3"}>
                <Button target={"secondary"} onClick={() => setShowKmzPanel(false)}>
                    Cancelar
                </Button>
                <Button onClick={add}>
                    <FaCheck /> Confirmar
                </Button>
            </div>
        </>
    );
};

export default PanelKmz;